import type { ReleaseT } from '../types'

const release: ReleaseT = {
  usefulContent: {
    description:
      'React Native 0.73 includes an updated process for the iOS privacy manifest, now required by Apple',
    links: [
      {
        title: "Learn how to update your app's Apple privacy settings",
        url: 'https://github.com/react-native-community/discussions-and-proposals/discussions/776',
      },
    ],
  },
  comments: [],
}

export default release
